import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {connect} from "trim-redux";
import {withRouter} from 'react-router-dom';
import withWidth from "@material-ui/core/withWidth/withWidth";
import Navigation from "./VerticleNav";
import {Styles} from "../../../../config/design/styles";
import Tabs from "@material-ui/core/Tabs/Tabs";
import Tab from "@material-ui/core/Tab/Tab";
import {Translate} from "../../../../config/Translate";
import Box from "@material-ui/core/Box";

class NavigationHolder extends React.Component{
    classes = this.props.classes;
    state = {
        TabId: "admin",
    };
    handleTabChange = (event, newValue) => {
        this.setState({
            TabId: newValue
        })
    };
    componentDidMount() {
        let {user} = this.props;
        let role_type = user.role.type;
        let role_name = user.role.name;
        if(role_name === "supplier"){
            this.setState({
                TabId: "supplier"
            })
        }else if(role_name === "user"){
            this.setState({
                TabId: "user"
            })
        }else if(role_name === "marketer"){
            this.setState({
                TabId: "marketer"
            })
        }
    }

    render(){
        let {TabId} = this.state;
        let {user} = this.props;
        let role_type = user.role.type;
        let role_name = user.role.name;
        return(
            <Box>
                {
                    role_name !== "user" &&
                        <Tabs
                            value={TabId}
                            onChange={this.handleTabChange.bind(this)}
                            indicatorColor="secondary"
                            variant="fullWidth"
                            textColor="secondary"
                            className="menu-roles-tabs"
                            style={{
                                backgroundColor: "#747474",
                                borderTop: "2px solid #F4F7FE",
                                borderBottom: "2px solid #F4F7FE",
                                padding: "8px 10px",
                            }}
                        >
                            {
                                role_type === "admin" &&
                                <Tab value="admin"  label={Translate.adminMenu}
                                    style={{color:"#fff",minHeight:37}}
                                />
                            }
                            {
                                ((role_type === "admin" && !!user.shops[0]) || role_name === "supplier") &&
                                <Tab value="supplier"
                                     label={Translate.supplierMenu}
                                     style={{color:"#fff",minHeight:37}}
                                />
                            }
                            {
                                ( role_name === "marketer") &&
                                <Tab
                                    value="marketer"
                                    label={Translate.marketerMenu}
                                    style={{color:"#fff",minHeight:37}}
                                />
                            }
                            {
                                ( role_name === "supplier" || role_name === "marketer") &&
                                <Tab
                                    value="user"
                                    label={Translate.userMenu}
                                    style={{color:"#fff",minHeight:37}}
                                />
                            }
                        </Tabs>
                }

                {
                    <Navigation type={TabId}/>

                }
            </Box>
        )
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    global_loading:state.global_loading,
    logo:state.logo
});
export default withWidth()(withStyles(Styles)(withRouter(connect(mstp)(NavigationHolder))));
